var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrivateBath(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M4.385 3.818h16.923V22H4.385z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.923 8.545)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 6.106h12.826l-.164.829a4 4 0 01-3.924 3.224h-4.65a4 4 0 01-3.924-3.224L3 6.105h0z",
    stroke: "#666",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666",
    strokeLinecap: "round",
    d: "M12.889 10.159l.593 1.621"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#000",
    cx: 1.509,
    cy: 1.242,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: 4.272,
    cy: 3.363,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#666"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.29 1.629h2.633v16.553c-.585-.589-1.023-.883-1.316-.883-.293 0-.732.294-1.316.883V1.629zM5.923 1.629h2.633v16.553a4.557 4.557 0 00-1.317-.883c-.45-.191-.829-.191-1.134 0L5.923 1.63z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.556 1.629h2.632v16.553a4.557 4.557 0 00-1.316-.883c-.451-.191-.85-.23-1.194-.115L8.556 1.63z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.847 1.63h20.661"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: 0.658,
    cy: 1.629,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: 20.966,
    cy: 1.629,
    r: 1
  }))))));
}
export default SvgPrivateBath;